export default "__VITE_ASSET__BMG4XqTA__"